import { render, staticRenderFns } from "./CustomReportConfig.vue?vue&type=template&id=cca95a0a"
import script from "./CustomReportConfig.vue?vue&type=script&lang=js"
export * from "./CustomReportConfig.vue?vue&type=script&lang=js"
import style0 from "./CustomReportConfig.vue?vue&type=style&index=0&id=cca95a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports